var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('w-row',[_c('w-col',{attrs:{"xs":"12"}},[_c('app-product-sku-autocomplete',{attrs:{"label":_vm.label,"fancy":""},model:{value:(_vm.product),callback:function ($$v) {_vm.product=$$v},expression:"product"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }